module.exports = __webpack_public_path__ + "static/media/meme_12.f207e0b6.jpg";